import { IDENTITY_SERVICE_BASE_URL } from "constants";
import apiClient from "utils/apiClient";

export async function initiateLinkedInWebSignIn(returnTo) {
  const { data } = await apiClient.get(
    `${IDENTITY_SERVICE_BASE_URL}/api/v1/auth/linkedin/web`,
    { params: { returnTo } },
  );
  return { redirectUrl: data?.redirect_url || data?.redirectUrl || "" };
}

export async function startEmailVerification() {
  const { data } = await apiClient.post(`${IDENTITY_SERVICE_BASE_URL}/api/v1/auth/verification/email/start`, {});
  return data;
}

export async function verifyEmail(otpToken, code) {
  const { data } = await apiClient.post(`${IDENTITY_SERVICE_BASE_URL}/api/v1/auth/verification/email/verify`, { otpToken, code });
  return data;
}

export async function startPhoneVerification(phone) {
  const { data } = await apiClient.post(`${IDENTITY_SERVICE_BASE_URL}/api/v1/auth/verification/phone/start`, phone ? { phone } : {});
  return data;
}

export async function verifyPhone(otpToken, code) {
  const { data } = await apiClient.post(`${IDENTITY_SERVICE_BASE_URL}/api/v1/auth/verification/phone/verify`, { otpToken, code });
  return data;
}
